import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { DateRangePicker } from "materialui-daterange-picker";

export default function DateRangePickerModal({ open, handleClose, handleChangeDate, dateRange }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={isMobile ? 'sm' : 'md'}
                fullScreen={isMobile}
                PaperProps={{
                    style: { 
                        borderRadius: isMobile ? 0 : 15,
                        margin: isMobile ? 0 : 32
                    }
                }}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent style={{ 
                    padding: isMobile ? '16px' : '24px',
                    overflow: 'auto'
                }}>
                    <Grid container spacing={isMobile ? 2 : 5}>
                        <Grid item xs={12}>
                            <DateRangePicker
                                open={true}
                                initialDateRange={dateRange || null}
                                onChange={handleChangeDate}
                                wrapperClassName={"dateRangeWrapper"}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{
                    padding: isMobile ? '12px 16px' : '16px 24px',
                    gap: isMobile ? '8px' : '12px'
                }}>
                    <Button 
                        variant="outlined" 
                        onClick={handleClose} 
                        color="primary"
                        size={isMobile ? "small" : "medium"}
                        fullWidth={isMobile}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="outlined" 
                        onClick={handleClose} 
                        color="primary"
                        size={isMobile ? "small" : "medium"}
                        fullWidth={isMobile}
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
}